import React, { Component } from 'react'

import { FormattedMessage } from 'react-intl'
import cx from 'classnames'

import { LOCALE_PREFIX } from './constants'

import './style.scss'

export default class InsolvencyTooltip extends Component {
    render() {
        return (
            <div>
                <div>
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.insolvencyTooltipMain`}
                        values={{ strong: (chunks) => <strong>{chunks}</strong>, br: <br /> }}
                    />
                </div>
                <div className={cx('tooltip-insolvency-icon', 'na')}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.insolvencyNo`} />
                </div>
                <div className={cx('tooltip-insolvency-icon', 'insolvency-present')}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.insolvencyActive`} />
                </div>
                <div className={cx('tooltip-insolvency-icon', 'insolvency-past')}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.insolvencyHistorical`} />
                </div>
                <div>
                    <FormattedMessage id={`${LOCALE_PREFIX}.insolvencyFooter`} />
                </div>
            </div>
        )
    }
}
